
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {ITheme, SCAPIN_GREEN, SCAPIN_ORANGE, SCAPIN_RED} from '@/configs/colors';

  @Component
  export default class SbToolbarBtn extends Vue {
    // Les props
    @Prop({default: true}) private enabled!: boolean
    @Prop({default: ''}) private icon!: string
    @Prop({default: ''}) private tip!: string
    @Prop({default: ''}) private shortcut!: string
    @Prop({default: 'B'}) private color!: string
    @Prop({default: false}) private mx1!: boolean
    @Prop({default: false}) private valign!: boolean

    // Les propriétés
    // Les propriétés calculées
    private get theme(): ITheme {
      return this.$store.state.testcase.theme
    }

    private get tipColor() {
      return this.theme.tree ? this.theme.tree.root : undefined
    }

    private get btnColor() {
      const colors = new Map([
        ['B', this.theme.tree ?  this.theme.tree.folder : ''],
        ['G', SCAPIN_GREEN],
        ['O', SCAPIN_ORANGE],
        ['R', SCAPIN_RED]
      ])
      return colors.has(this.color) ? colors.get(this.color) : this.color
    }

    private get btnClass() {
      return `${this.mx1 ? 'mx-1' : ''} ${this.valign? 'valign' : ''}`
    }

    private get tooltip() {
      let t: string = this.tip
      if (this.shortcut.length) {
        t += `&nbsp;&nbsp;<i>${this.shortcut}</i>`
      }
      return t
    }

    // Les hooks
    // Les méthodes surveillées
    // Les méthodes d'instance
    // Les méthodes statiques
  }
